/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { ViewModel } from '../../../../../core/viewmodel/ViewModel';
import { DetailModel } from '../../../../../models/components/DetailModel';
import { StoreProvider } from '../../../../../stores/StoreProvider';
import * as H from 'history';
import { EntriesReviewStore } from '../../../../../stores/components/EntriesReviewStore';

export class EntryDetailViewModel extends ViewModel {
	private readonly model = new DetailModel();
	private readonly entriesReviewStore: EntriesReviewStore;

	constructor(storeProvider: StoreProvider, history: H.History) {
		super(storeProvider, history);
		this.entriesReviewStore = storeProvider.entriesReviewStore;
	}

	public closeDetailView(): void {
		this.entriesReviewStore.closeDetailView();
	}

	public getShowDetailImage(): boolean {
		return this.model.showDetailImage;
	}

	public setShowDetailImage(bool: boolean): void {
		this.model.setShowDetailImage(bool);
	}

	public getDaysUntilRemoval(rejectedDate: string): number {
		const date = new Date(rejectedDate).getTime();
		const now = new Date().getTime();

		const daysSinceRejection = (now - date) / 24 / 60 / 60 / 1000;
		const deleteAfter = 7;
		return deleteAfter - Math.floor(daysSinceRejection);
	}
}
